import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProjectsComponent } from './projects.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { materialModule } from '../../material.module';
import { SettingsComponent } from "./settings/settings.component";
import { MainMenuBarComponent } from "./main-menu-bar/main-menu-bar.component";
import { SharedModule } from "../shared.module";

const routes: Routes = [
    {
        path: '',
        component: ProjectsComponent,
        children: [
            {
                path: 'manageProject',
                loadChildren: () => import(`./manage-projects/manage-projects-routing.module`).then(m => m.ManageProjectsRoutingModule)
            },
            {
                path: 'roofPlan',
                loadChildren: () => import(`./roof-plan/roof-plan-routing.module`).then(m => m.RoofPlanRoutingModule)
            },
            {
                path: 'inverterPlan',
                loadChildren: () => import(`./inverter-plan/inverter-plan-routing.module`).then(m => m.InverterPlanRoutingModule)

            },
            {
                path: 'createProject',
                loadChildren: () => import(`./create-project/create-project.module`).then(m => m.CreateProjectModule)
            }
            ,
            {
                path: 'settings',
                component: SettingsComponent
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        FlexLayoutModule,
        materialModule,
        SharedModule
    ],
    exports: [RouterModule],
    declarations: [
        ProjectsComponent,
        SettingsComponent,
        MainMenuBarComponent
    ]
})

export class ProjectsRoutingModule { }